import React from "react";
import {connect} from "react-redux";
import PricingCheckbox from "../PricingComponents/PricingCheckbox";


const PricingDetailsCheckboxes = (props) => {

  const {} = props;
  const [checked, setChecked] = React.useState(false);

  const onCheckBoxChange = () => {

  }

  return (
    <div className="ml-3 pr-details__checkboxes inactive">
      <PricingCheckbox id="other_colors"
                       text={"Allow Other Colors"}
                       className="mb-15"
                       checked={checked}
                       onChange={() => setChecked(!checked)}/>
      <PricingCheckbox id="allow_discount"
                       text={"Allow Discount"}
                       className="mb-15"
                       checked={checked}
                       onChange={() => setChecked(!checked)}/>
      <PricingCheckbox id="editable_price"
                       text={"Editable Price On Quote"}
                       className="mb-125"
                       checked={checked}
                       onChange={() => setChecked(!checked)}/>
      <span className="font--14 color-light">
        <span className="bold">Tax Code:</span> TAX
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {} = store.pricingState;
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PricingDetailsCheckboxes);
